<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
  data-test="create-template-dialog"
>
  <div class="flex--container">
    <!-- templateType select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'treatmentType' | translate }}</mat-label>
        <mat-select formControlName="templateType" data-test="create-template-treatment-type">
          @for (type of templateTypes; track type.value) {
            <mat-option [value]="type.value">
              {{ type.text }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- CropYear select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cropYear' | translate }}</mat-label>
        <mat-select formControlName="cropYear" data-test="create-template-crop-year">
          @for (cropYear of data.cropYears; track cropYear) {
            <mat-option [value]="cropYear">
              {{ cropYear }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Toggles -->
    <div class="flex--row flex--gutter">
      <!-- Skal slider -->
      <div class="flex__child--auto">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isSkal"
            data-test="create-template-is-skal"
          >
            {{ 'skal' | translate }}
          </mat-slide-toggle>
        </div>
      </div>

      <!-- PlanetProof slider -->
      <div class="flex__child--auto">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isPlanetProof"
            data-test="create-template-is-planet-proof"
          >
            {{ 'planetProof' | translate }}
          </mat-slide-toggle>
        </div>
      </div>

      <!-- GroundWaterPreservation slider -->
      <div class="flex__child--auto">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="isGroundWaterPreservation"
            data-test="create-template-is-groundWater-preservation"
          >
            {{ 'groundWaterPreservation' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <!-- Crop select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'crop' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'crop' | translate"
          matInput
          formControlName="cropId"
          [matAutocomplete]="cropAutocomplete"
          data-test="create-template-crop-filter"
        />
        <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
          @for (crop of filteredCrops$ | async; track crop.id) {
            <mat-option [value]="crop.id" data-test="create-template-crop-options">
              {{ crop.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- SoilType select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'soilType' | translate }}</mat-label>
        <mat-select formControlName="soilTypeId" data-test="create-template-soil-type">
          @for (soilType of data.soilTypes; track soilType.id) {
            <mat-option [value]="soilType.id">
              {{ soilType.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Province multi-select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'province' | translate }}</mat-label>
        <mat-select
          multiple
          formControlName="province"
          (selectionChange)="onProvinceSelectionChange($event)"
          data-test="create-template-provinces"
        >
          @for (province of provinces; track province) {
            <mat-option [value]="province.value">
              {{ province.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
